import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { UserLegalInfo } from 'src/app/shared/enums/enums'
import { DdcTextGradientComponent } from '../../shared/ddc/ddc-text-gradient/ddc-text-gradient.component'

@Component({
  selector: 'ddc-termsandconditions',
  templateUrl: './ddc-termsandconditions.component.html',
  styleUrls: ['./ddc-termsandconditions.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, RouterModule, DdcTextGradientComponent],
})
export class DdcTermsandconditionsComponent {
  _lastUpdate: string = UserLegalInfo.LAST_UPDATED
  _text: string = UserLegalInfo.TERMS_AND_CONDS
}
